var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLastfm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v24h24v-24h-24zm16.188 16.444c-3.17 0-4.27-1.429-4.856-3.207l-.587-1.833c-.44-1.338-.953-2.382-2.565-2.382-1.119 0-2.255.806-2.255 3.061 0 1.759.898 2.859 2.163 2.859 1.429 0 2.382-1.063 2.382-1.063l.587 1.595s-.99.971-3.061.971c-2.566-.001-3.996-1.503-3.996-4.289 0-2.896 1.43-4.6 4.124-4.6 2.438 0 3.666.879 4.436 3.262l.605 1.833c.439 1.338 1.209 2.31 3.061 2.31 1.246 0 1.906-.275 1.906-.953 0-.532-.312-.917-1.246-1.136l-1.246-.293c-1.521-.367-2.126-1.155-2.126-2.401 0-1.998 1.613-2.621 3.262-2.621 1.87 0 3.006.678 3.152 2.328l-1.833.22c-.073-.788-.549-1.118-1.429-1.118-.807 0-1.301.367-1.301.99 0 .55.238.879 1.044 1.062l1.173.257c1.575.365 2.418 1.135 2.418 2.62 0 1.832-1.54 2.528-3.812 2.528z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastfm);
export default __webpack_public_path__ + "static/media/lastfm.cad754a428ddb8ac877ac94b04b43137.svg";
export { ForwardRef as ReactComponent };